<script>
import { mapActions } from 'vuex';

export default {
  name: 'Dashboard',
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.general.title'), to: '', disabled: true },
        { text: this.$t('menu.general.pages.dashboard.title'), to: this.$route.path },
      ],
      title: this.$t('menu.general.pages.dashboard.title'),
    });
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
    }),
  },
};
</script>

<template>
  <v-flex xs12>
    <v-card-title>Dashboard</v-card-title>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue